import { Outlet } from "react-router-dom";
export default function PrivatePage() {
  return (
    <div>
      <Outlet />
    </div>
  );
}
